import axios, { AxiosInstance } from 'axios'
import axiosRetry from 'axios-retry'

import { authService } from '@/services/auth'
import { getApiBaseUrl } from '@/utils/api'

const axiosInstance: AxiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
})

// Add request interceptor to include auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const authHeader = authService.getAuthHeader()
    if (authHeader) {
      config.headers.Authorization = authHeader
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Add response interceptor to handle auth errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      authService.clearToken()
      // Optionally trigger a re-auth flow here
      window.location.reload()
    }
    return Promise.reject(error)
  }
)

axiosRetry(axiosInstance)

export default axiosInstance
